<template>
  <div class="grid-x align-center-middle background-hover">
    <div class="picture-grey"></div>
  </div>
</template>

<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/_picture-grey.scss';

.background-hover {
  background: $hover-color;
}
</style>
